@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        <topo-color-picker
          [selectedColor]="displayValue"
          (selectedColorChanged)="colorChanged($event)"
        [selectedColorWidth]="72"></topo-color-picker>
      </div>
    } @else {
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <topo-color-display
          [htmlColorCode]="displayValue"
        [showHtmlColorCode]="true"></topo-color-display>
      </div>
    }
  </div>
}
